function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "./src/app/base-components recursive .ts$";


//////////////////
// WEBPACK FOOTER
// ./src/app/base-components .ts$
// module id = ./src/app/base-components recursive .ts$
// module chunks = main